import * as THREE from 'three';

const SPHERE_GEO = new THREE.SphereGeometry(1, 14, 10);
const RING_GEO = new THREE.RingGeometry(0.85, 1.15, 28);

// Short-lived rocket-hit "boom": a bright orange core sphere that expands
// and fades, plus a flat yellow shockwave ring that expands faster on the
// horizontal plane. Each is purely visual; cleanup is driven by update()
// returning true when the lifetime is up.
export class Explosion {
  constructor(scene, position) {
    this.group = new THREE.Group();
    this.group.position.set(position.x, position.y + 1, position.z);

    this.coreMat = new THREE.MeshBasicMaterial({
      color: 0xfb923c,
      transparent: true,
      opacity: 1,
    });
    this.core = new THREE.Mesh(SPHERE_GEO, this.coreMat);
    this.core.scale.setScalar(0.4);
    this.group.add(this.core);

    this.ringMat = new THREE.MeshBasicMaterial({
      color: 0xfde047,
      transparent: true,
      opacity: 1,
      side: THREE.DoubleSide,
    });
    this.ring = new THREE.Mesh(RING_GEO, this.ringMat);
    this.ring.rotation.x = -Math.PI / 2;
    this.ring.scale.setScalar(0.4);
    this.group.add(this.ring);

    this.lifetime = 0;
    this.maxLifetime = 0.6;
    scene.add(this.group);
  }

  // dt in seconds; returns true once the explosion has finished its
  // animation and is ready to be destroyed.
  update(dt) {
    this.lifetime += dt;
    const t = this.lifetime / this.maxLifetime;
    if (t >= 1) return true;
    const coreScale = 0.4 + t * 4.5;
    this.core.scale.setScalar(coreScale);
    this.coreMat.opacity = Math.max(0, 1 - t * 1.1);
    const ringScale = 0.4 + t * 9;
    this.ring.scale.setScalar(ringScale);
    this.ringMat.opacity = Math.max(0, 1 - t * 1.3);
    return false;
  }

  destroy() {
    this.group.parent?.remove(this.group);
    this.coreMat.dispose();
    this.ringMat.dispose();
  }
}
